import { RoomId } from "../../interface";
import { RoomLiveStatus } from "../../type";
import { BaseVO } from "../base.vo";

export class RoomLiveStreamStatusUpdateEventVO extends BaseVO<RoomLiveStreamStatusUpdateEventVORaw> {}

export interface RoomLiveStreamStatusUpdateEventVORaw {
  id: RoomId;
  status: RoomLiveStatus;
}
